<template>
    <v-app>
        <router-view></router-view>
        <PopUp/>
    </v-app>
</template>

<script>
import PopUp from '@/components/PopUp';

/**
 * App component is the main component of the vue application and includes the
 * PopUp component to make it common to the resto of the app components.
 */
export default {
    name: 'App',
    components: { PopUp }
}
</script>

<style>
* {font-size: 1.003em;}

.v-card__title { word-break: break-word; }

.v-application {background-color: var(--v-background-base) !important;}

/* .dd-input fieldset {
    border-color: transparent;
    background-color: var(--v-ddblack-base);
} */
</style>
